import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import Link from "@amzn/meridian/esm/components/link";
import summaryStopped from "../../images/summary_stop.svg";
import zoomSdk from "@zoom/appssdk";
import LogManager from "../utils/LogManager";

/**
 * Component shown when transcription has stopped
 * Uses the same visual format as SummarizeStopped but simplified for transcription
 */
const TranscribeStopped = () => {
  const handleGoToHireClick = async () => {
    try {
      await zoomSdk.openUrl({
        url: "https://hire.amazon.com/interviewing",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Column alignmentHorizontal="start" width="100%" position="relative" spacing="none" spacingInset="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
          <Box type="outline" spacingInset="none" minWidth="15px" />
        </Theme>
        <Box width="340px" position="relative">
        <img src={summaryStopped} alt="transcriptionStopped" style={{ display: "block", margin: "auto", maxWidth: "100%", height: "auto" }} />
        </Box>
      </Row>
      <Column height="16px" spacing="none" />
      <Column spacing="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px" />
          </Theme>
          <Text fontFamily="amazonEmber" type="h50" alignment="start">
            Transcription stopped
          </Text>
        </Row>
      </Column>
      <Column height="16px" spacing="none" />
      <Column spacing="none" spacingInset="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px" />
          </Theme>
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" maxWidth="239px">
              <Theme tokens={{ textListSpacingVertical: "160px" }}>
                <Text fontFamily="amazonEmber" type="b200" alignment="start" color="secondary">
                  Start taking notes if needed.
                </Text>
              </Theme>
            </Box>
          </Theme>
        </Row>
        <Row height="8px"/>
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px" />
          </Theme>
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" maxWidth="239px">
              <Theme tokens={{ textListSpacingVertical: "160px" }}>
                <Text fontFamily="amazonEmber" type="b200" alignment="start" color="secondary">
                  You'll find transcript in Hire when it's ready.
                </Text>
              </Theme>
            </Box>
          </Theme>
        </Row>
      </Column>
      <Column height="16px" spacing="none" />
      <Column spacing="none" spacingInset="none">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" minWidth="68px" />
          </Theme>
          <Link onClick={handleGoToHireClick} type="secondary">
            <Theme tokens={{ textColorPrimary: "#006D5B" }}>
              <Text color="primary" type="b200" fontFamily="amazonEmber">
                <u>Go to Hire</u>
              </Text>
            </Theme>
          </Link>
        </Row>
      </Column>
    </Column>
  );
};

export default TranscribeStopped;
